const sheetLink = function (sheet = null) {
  if (sheet) {
    const baseUrl = this.$config.apiUrl || ''
    const brand = this.$config.brand
    return `${baseUrl}/api/document/product-information-sheet/${brand}/${sheet.documentReference}.pdf`
  } else {
    return '#'
  }
}

export default {
  methods: {
    sheetLink
  }
}
